__turbopack_context__.v({
  "full_height": "styles-module-scss-module__tWv9-q__full_height",
  "full_width": "styles-module-scss-module__tWv9-q__full_width",
  "grid_item": "styles-module-scss-module__tWv9-q__grid_item",
  "shimmer": "styles-module-scss-module__tWv9-q__shimmer",
  "skeleton": "styles-module-scss-module__tWv9-q__skeleton",
});
